import styles from './styles.module.scss';

import { useContext, useState } from 'react';
import { Input } from '../Input';
import { SelectionItem, SelectionListItem } from '../SelectionListItem';
import { MessageContext } from '../../providers/MessageProvider';

export interface SelectionListProps extends React.HTMLAttributes<HTMLDivElement> {
    items: SelectionItem[];
    defaultSelectedItem?: SelectionItem;
    onSelectItem: Function;
    searchPlaceholder?: string;
    wrapperClass?: string;
}

export const SelectionList = ({
    items,
    defaultSelectedItem,
    onSelectItem,
    searchPlaceholder,
    wrapperClass,
    ...rest
}: SelectionListProps) => {
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const [search, setSearch] = useState<string>('');
    const [selectedItem, setSelectedItem] = useState<SelectionItem | undefined>(
        defaultSelectedItem
    );
    const [maxRender, setMaxRender] = useState<number>(20);
    let itemsRendered: number = 0;

    items.sort((item1, item2) => item1.name.localeCompare(item2.name));

    const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
    };

    const onClickItem = async (item: SelectionItem) => {
        try {
            const operationSuccess = await onSelectItem(item.id);

            if (operationSuccess) {
                setSelectedItem(item);
            }
        } catch (error: any) {
            setMessage({
                type: 'error',
                content: 'Erro ao selecionar usuário'
            });
            setOpenMessage(true);
        }
    };

    const renderSelectedItem = () => {
        if (selectedItem) {
            let currentSelectedItem: any = null;

            items.forEach(item => {
                if (item.id == selectedItem.id) {
                    currentSelectedItem = item;
                }
            });

            if (currentSelectedItem) {
                itemsRendered++;

                return (
                    <SelectionListItem
                        key={currentSelectedItem.id}
                        image={currentSelectedItem.image}
                        name={currentSelectedItem.name}
                        description={currentSelectedItem.description}
                        isSelected={true}
                        onClick={() => onClickItem(currentSelectedItem)}
                    />
                );
            }
        }

        return;
    };

    const renderMoreItems = () => {
        return (
            <SelectionListItem
                key='moreItems'
                name='Carregar mais...'
                onClick={() => setMaxRender(maxRender + 20)}
            />
        );
    };

    const renderItem = (item: SelectionItem) => {
        const matchName = item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        const matchDescription =
            item.description &&
            item.description.toLocaleLowerCase().includes(search.toLocaleLowerCase());

        if ((matchName || matchDescription) && itemsRendered < maxRender) {
            if (!selectedItem || (selectedItem && item.id !== selectedItem.id)) {
                itemsRendered++;

                return (
                    <SelectionListItem
                        key={item.id}
                        image={item.image}
                        name={item.name}
                        description={item.description}
                        isSelected={false}
                        onClick={() => onClickItem(item)}
                    />
                );
            }
        } else if (itemsRendered === maxRender) {
            itemsRendered++;
            return renderMoreItems();
        }

        return;
    };

    return (
        <div className={`${wrapperClass ?? ''} ${styles.wrapper}`} {...rest}>
            <Input
                inputWrapperClass={styles.search}
                type='text'
                value={search}
                onChange={onSearchChange}
                //placeholder={searchPlaceholder}
            />

            <div className={styles.itemsWrapper}>
                {renderSelectedItem()}
                {items.map(renderItem)}
            </div>
        </div>
    );
};
